/* eslint-disable global-require */

export default [
  {
    path: '/reviews',
    getChildRoutes(partialNextState, callback) {
      require.ensure(
        [],
        () =>
          callback(null, [
            {
              path: ':id',
              indexRoute: { component: require('./pages/ReviewPage').default },
              childRoutes: [
                { path: 'like', component: require('./pages/LikeReviewPage').default },
                {
                  path: 'dislike',
                  component: require('./pages/DislikeReviewPage').default,
                },
              ],
            },
            { path: '*', component: require('./pages/NotFoundPage').default },
          ]),
        'reviews'
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/reviews/routes.js